import React, { useContext, useLayoutEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import {
  Grid,
  SearchBar,
  SearchContext,
  SearchContextManager,
  SuggestionBar,
} from '@giphy/react-components';
import { Image } from '@bufferapp/components';
import PropTypes from 'prop-types';
import {
  AttributionMarkWrapper,
  GiphyContentWrapper,
  GiphyWrapper,
  SearchBarWrapper,
  SuggestionBarWrapper,
} from './style';

const webSDKKey = process.env.GIPHY_KEY;

const calculateWidth = width => {
  if (width > 1209) {
    return 990;
  }
  if (width > 959) {
    return 840;
  }
  if (width > 759) {
    return width - 120;
  }
  return width - 60;
};

const getWidth = () => {
  const [width, setWidth] = useState(calculateWidth(window.innerWidth));

  useLayoutEffect(() => {
    const adjustWidth = () => {
      const { innerWidth } = window;
      setWidth(calculateWidth(innerWidth));
    };

    window.addEventListener('resize', adjustWidth);
    adjustWidth();
    return () => window.removeEventListener('resize', adjustWidth);
  }, []);

  return width;
};

const GiphyIntegration = ({ onGifClick }) => {
  return (
    <GiphyWrapper>
      <GiphyContentWrapper>
        <SearchContextManager
          apiKey={webSDKKey}
          shouldDefaultToTrending
          options={{ offset: true, limit: 10 }}
        >
          <SearchComponents onGifClick={onGifClick} />
        </SearchContextManager>
      </GiphyContentWrapper>
      <AttributionMarkWrapper>
        <Image
          src="https://buffer-publish.s3.amazonaws.com/images/giphy_attribution_mark.png"
          alt="Powered by Giphy attribution mark"
          width="150px"
        />
      </AttributionMarkWrapper>
    </GiphyWrapper>
  );
};

GiphyIntegration.propTypes = {
  onGifClick: PropTypes.func.isRequired,
};

const SearchComponents = ({ onGifClick }) => {
  const width = getWidth();
  const { fetchGifs, searchKey } = useContext(SearchContext);

  return (
    <>
      <SearchBarWrapper>
        <SearchBar />
      </SearchBarWrapper>
      <SuggestionBarWrapper>
        <SuggestionBar />
      </SuggestionBarWrapper>
      <Grid
        key={searchKey}
        onGifClick={(gif, e) => {
          onGifClick(gif, e);
        }}
        fetchGifs={fetchGifs}
        width={width}
        columns={3}
        hideAttribution
        noResultsMessage="No Results Found"
      />
    </>
  );
};

SearchComponents.propTypes = {
  onGifClick: PropTypes.func.isRequired,
};

const giphyIntegrationTab = (container, _button, dialogApi) => {
  const onGifClick = (gif, e) => {
    e.preventDefault();
    const { url } = gif.images.downsized;

    dialogApi.addFiles('url', [
      [
        url,
        {
          source: 'url-tab',
        },
      ],
    ]);
  };

  ReactDOM.render(
    React.createElement(GiphyIntegration, { onGifClick }),
    container[0]
  );
};

export default giphyIntegrationTab;
